import { createFileRoute } from '@tanstack/react-router';
import { Package } from 'lucide-react';
import { SelectionPlaceholder } from '@/components/molecules';

export const Route = createFileRoute('/_dashboard/dashboard/pricebook/')({
  component: PricebookIndex,
});

function PricebookIndex() {
  return (
    <SelectionPlaceholder
      icon={Package}
      title="Select an item to view details"
      iconClassName="h-9 w-9 text-muted-foreground/30"
      className="flex h-full flex-col items-center justify-center gap-2 py-16 text-muted-foreground"
    />
  );
}
